const { request, setAccessToken, getAccessToken, clearSavedCredentials } = require('./apiClient');

function signup(input) {
  return request('/auth/signup', {
    method: 'POST',
    body: input
  }).then(function(result) {
    setAccessToken(result && result.token);
    return result && result.user;
  });
}

function signin(input) {
  return request('/auth/signin', {
    method: 'POST',
    body: input
  }).then(function(result) {
    setAccessToken(result && result.token);
    return result && result.user;
  });
}

// Google Identity Services login — `credential` is the signed ID token from
// the GSI button. Same {token, user} contract as signin.
function signinWithGoogle(credential) {
  return request('/auth/google', {
    method: 'POST',
    body: { credential: String(credential || '') }
  }).then(function(result) {
    setAccessToken(result && result.token);
    return result && result.user;
  });
}

function requestPasswordReset(email) {
  return request('/auth/forgot-password', {
    method: 'POST',
    body: { email: String(email || '').trim() }
  });
}

function resetPassword(token, newPassword) {
  return request('/auth/reset-password', {
    method: 'POST',
    body: { token: String(token || ''), newPassword: String(newPassword || '') }
  });
}

function loadCurrentUser() {
  if (!getAccessToken()) {
    return Promise.resolve(null);
  }

  return request('/auth/me')
    .then(function(result) {
      return result && result.user ? result.user : null;
    })
    .catch(function() {
      setAccessToken('');
      return null;
    });
}

function signout() {
  setAccessToken('');
  clearSavedCredentials();
}

function resetUsage() {
  return request('/user/reset-usage', { method: 'POST' });
}

function loadUsageHistory(bucket, range) {
  var b = encodeURIComponent(bucket || 'day');
  var r = range ? '&range=' + encodeURIComponent(range) : '';
  return request('/user/usage/history?bucket=' + b + r);
}

module.exports = {
  signup: signup,
  signin: signin,
  signinWithGoogle: signinWithGoogle,
  signout: signout,
  requestPasswordReset: requestPasswordReset,
  resetPassword: resetPassword,
  loadCurrentUser: loadCurrentUser,
  resetUsage: resetUsage,
  loadUsageHistory: loadUsageHistory
};
